module.exports = __webpack_public_path__ + "img/keen-v.3b428d09.jpg";